import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  // CSidebarNavDropdown,
  CSidebarNavItem,
  CSidebarMinimizer,
} from '@coreui/react';

import logo from '../assets/images/logo4.png';
import logo_mini from '../assets/images/logo_mini.png';
import Highcharts from 'highcharts';
import { ApplicationState } from '../store';
import { useLocation } from 'react-router-dom';
import navigation_ja, { Navigation } from './_nav_ja';
import navigation_en from './_nav_en';
import { useTranslation } from 'react-i18next';
import { I18nUse } from '../utils/I18nUse';
import { AuthUser, getCurrentUser } from '@aws-amplify/auth';
// サイト概要 アイテム
// const createDropdownItems = (sites) => {
//   return sites ? sites.map( site => (
//     {
//       _tag: 'CSidebarNavItem',
//       name: site.name,
//       to: '/sites/'+ site.id ,
//     }
//   )) : [];
// }

const TheSidebar: React.FC = () => {
  const dispatch = useDispatch();
  const show = useSelector((state: ApplicationState) => state.sidebarShow);
  const minimize = useSelector((state: ApplicationState) => state.sidebarMinimize);
  const servicePermissions = useSelector((state: ApplicationState) => state.servicePermissions);
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState<AuthUser | null>(null);
  useEffect(() => {
  const fetchUser = async () => {
    try {
      const user = await getCurrentUser();
      setCurrentUser(user);
    } catch (error) {
      setCurrentUser(null);
    }
  };
  fetchUser();
  }, []);
  const state_lang = useSelector((state: ApplicationState) => state.lang);
  const [t, i18n] = useTranslation();
  const [lang, setLang] = useState(state_lang);
  let navigation = navigation_ja;

  if (state_lang == 'en') {
    navigation = navigation_en;
  }

  useEffect(() => {
    if (location.pathname === '/plan-execution' || location.pathname === '/bid-plan-profit') {
      dispatch({ type: 'set', sidebarMinimize: true });
    } else {
      dispatch({ type: 'set', sidebarMinimize: false });
    }
  }, [location.pathname]);
  useEffect(() => {
    // サイトバーの表示／非表示を変えるとき、Highchartsの幅を
    // コンテナにあわせて表示するようにエベントを追加
    window.addEventListener('transitionend', () => {
      Highcharts.charts.forEach((chart, idx, array) => {
        if (typeof chart !== 'undefined') {
          chart.reflow();
        }
      });
    });
  });
  const accesssAllowedServiceIds = useMemo(() => {
    return servicePermissions
      .filter((permission) => permission.is_access_allowed)
      .map((permission) => permission.service_id);
  }, [servicePermissions]);

  const filteredNavigation = useMemo(() => {
    const filterNavigation = (items: Navigation[]) => {
      return items.filter((item: Navigation) => {
        if (!item.service_id) return true;
        return accesssAllowedServiceIds.includes(item.service_id);
      });
    };

    return filterNavigation(navigation);
  }, [navigation, accesssAllowedServiceIds]);
  return (
    <CSidebar
      show={show}
      onShowChange={(val: boolean | '' | 'responsive' | undefined) =>
        dispatch({ type: 'set', sidebarShow: val })
      }
      className="sed-om-sidebar"
      minimize={minimize}
    >
      <CSidebarBrand className="d-md-down-none sed-om-sidebar-brand">
        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-full">
          <div className="logo">
            <img src={logo} alt={t('自然電力')} />
          </div>
          <p className="site">{t('取引支援システム(Demo)')}</p>
          {currentUser?.signInDetails?.['loginId'] && <p className="name">{currentUser?.signInDetails?.['loginId']}</p>}
        </div>

        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-minimized">
          <div className="logo">
            <img src={logo} alt={t('自然電力')} />
          </div>
        </div>
      </CSidebarBrand>

      <CSidebarNav>
        <CCreateElement
          items={filteredNavigation}
          components={{
            CSidebarNavDivider,
            //CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>

      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
